<section class="ecb-x-admin-list-section">

    <div class="container-fluid">

        <div class="ecb-x-admin-list-card">

            <!-- ======================================================= -->
            <!-- HEADER -->
            <!-- ======================================================= -->

            <div class="d-flex justify-content-between
           align-items-center mb-4 flex-wrap gap-2">

                <div>

                    <h1 class="ecb-section-title">
                        General Enquiries & Bookings
                    </h1>

                    <p class="ecb-muted mb-0">
                        View corporate and general training enquiry details.
                    </p>

                </div>


                <div class="ecb-enquiry-record-count">

                    {{ totalRecords }}

                    Enquir{{ totalRecords === 1 ? 'y' : 'ies' }}

                </div>

            </div>


            <!-- ======================================================= -->
            <!-- FILTERS -->
            <!-- ======================================================= -->

            <div class="ecb-enquiry-filter-wrapper">

                <div class="row g-3 align-items-end">

                    <!-- Approval -->
                    <div class="col-12 col-md-3 col-lg-2">

                        <label class="ecb-enquiry-filter-label">
                            Enquiry Type
                        </label>


                        <select class="form-select" [(ngModel)]="selectedEnquiryType" name="enquiryType">

                            <option value="">
                                All
                            </option>

                            <!--    <option value="CORPORATE_BOOKING">
                        Corporate
                    </option>
 -->
                            <option value="MULTI_COURSE_ENQUIRY">
                                Popular Courses
                            </option>

                            <option value="OTHER_COURSE_ENQUIRY">
                                Other Courses
                            </option>

                        </select>

                    </div>


                    <!-- Approval -->
                    <div class="col-12 col-md-3 col-lg-2">

                        <label class="ecb-enquiry-filter-label">
                            Approval Status
                        </label>


                        <select class="form-select" [(ngModel)]="selectedApprovalStatus" name="approvalStatus">

                            <option value="ALL">
                                All
                            </option>

                            <option value="APPROVED">
                                Approved
                            </option>

                            <option value="PENDING">
                                Pending
                            </option>

                        </select>

                    </div>


                    <!-- Active -->
                    <div class="col-12 col-md-4 col-lg-2">

                        <label class="ecb-enquiry-filter-label">
                            Record Status
                        </label>


                        <select class="form-select" [(ngModel)]="selectedActiveStatus" name="activeStatus">

                            <option value="ALL">
                                All
                            </option>

                            <option value="ACTIVE">
                                Active
                            </option>

                            <option value="INACTIVE">
                                Inactive
                            </option>

                        </select>

                    </div>


                    <!-- Apply -->
                    <div class="col-6 col-md-2">

                        <button type="button" class="btn ecb-enquiry-filter-button" (click)="applyFilters()">

                            <i class="bi bi-funnel"></i>

                            Apply

                        </button>

                    </div>


                    <!-- Clear -->
                    <div class="col-6 col-md-2">

                        <button type="button" class="btn ecb-enquiry-clear-button" (click)="clearFilters()">

                            <i class="bi bi-arrow-clockwise"></i>

                            Clear

                        </button>

                    </div>

                </div>

            </div>


            <!-- ======================================================= -->
            <!-- TABLE -->
            <!-- ======================================================= -->

            <p-table [value]="enquiries" [loading]="isLoading" [scrollable]="true"
                [tableStyle]="{'min-width': '1500px'}" styleClass="ecb-admin-table ecb-x-enquiry-table">


                <!-- =====================================================
       Header
  ====================================================== -->

                <ng-template pTemplate="header">

                    <tr class="ecb-admin-table-header-row">

                        <th class="ecb-admin-table-header text-center" style="width:85px;">
                            ID
                        </th>

                        <th class="ecb-admin-table-header text-center">
                            Client
                        </th>

                        <th class="ecb-admin-table-header">
                            Company
                        </th>

                        <th class="ecb-admin-table-header">
                            Requested By
                        </th>

                        <th class="ecb-admin-table-header text-center">
                            Participants
                        </th>

                        <th class="ecb-admin-table-header text-center">
                            UOC
                        </th>

                        <th class="ecb-admin-table-header text-center">
                            VOC
                        </th>

                        <th class="ecb-admin-table-header text-center">
                            Enquiry Status
                        </th>

                        <th class="ecb-admin-table-header text-center">
                            Status
                        </th>
                        <th class="ecb-admin-table-header">
                            Training Date
                        </th>
                        <th class="ecb-admin-table-header">
                            Created Date
                        </th>

                        <th class="ecb-admin-table-header ecb-admin-table-action-header">
                            Action
                        </th>

                        <th class="ecb-admin-table-header text-center">
                            Registration
                        </th>

                    </tr>

                </ng-template>


                <!-- =====================================================
       Body
  ====================================================== -->

                <ng-template pTemplate="body" let-enquiry>

                    <tr class="ecb-admin-table-row">


                        <!-- ID -->
                        <td class="ecb-admin-table-cell">

                            <span class="ecb-enquiry-id">
                                #{{ ReferencePrefix }}{{ enquiry.id }}
                            </span>

                        </td>


                        <!-- Client Type -->
                        <td class="ecb-admin-table-cell text-center">

                            <span class="ecb-enquiry-client-type" [ngClass]="{
            'ecb-enquiry-client-corporate':
              getClientType(enquiry)?.toUpperCase() === 'CORPORATE',

            'ecb-enquiry-client-general':
              getClientType(enquiry)?.toUpperCase() === 'GENERAL',
                 'ecb-enquiry-client-other':
              getClientType(enquiry)?.toUpperCase() === 'OTHER_COUR'
          }">

                                {{
                                getClientType(enquiry)?.toUpperCase() === 'OTHER_COUR'
                                ? 'OTHER'
                                : getClientType(enquiry)
                                }}

                            </span>

                        </td>


                        <!-- Company -->
                        <td class="ecb-admin-table-cell">

                            <div class="ecb-enquiry-company">
                                {{ getCompanyName(enquiry) }}
                            </div>

                        </td>


                        <!-- Requested By -->
                        <td class="ecb-admin-table-cell">

                            <div class="ecb-enquiry-requested-by">

                                <strong>
                                    {{ getRequestedBy(enquiry) }}
                                </strong>

                                <small *ngIf="getRequestedByPhone(enquiry) !== '-'">

                                    {{ getRequestedByPhone(enquiry) }}

                                </small>

                            </div>

                        </td>


                        <!-- Participants -->
                        <td class="ecb-admin-table-cell text-center">

                            <span class="ecb-enquiry-count">

                                {{ getParticipantCount(enquiry) }}

                            </span>

                        </td>


                        <!-- UOC -->
                        <td class="ecb-admin-table-cell text-center">

                            <span class="ecb-enquiry-training-count ecb-enquiry-uoc-count">

                                {{ getTotalUOC(enquiry) }}

                            </span>

                        </td>


                        <!-- VOC -->
                        <td class="ecb-admin-table-cell text-center">

                            <span class="ecb-enquiry-training-count ecb-enquiry-voc-count">

                                {{ getTotalVOC(enquiry) }}

                            </span>

                        </td>


                        <!-- Enquiry Status -->
                        <td class="ecb-admin-table-cell text-center">

                            <span class="ecb-enquiry-approval-status" [ngClass]="{
            'ecb-enquiry-approved':
              enquiry.isApproved,

            'ecb-enquiry-pending':
              !enquiry.isApproved
          }">

                                {{
                                enquiry.isApproved
                                ? 'Accepted'
                                : 'Pending'
                                }}

                            </span>

                        </td>


                        <!-- Active Status -->
                        <td class="ecb-admin-table-cell text-center">

                            <span class="ecb-enquiry-active-status" [ngClass]="{
            'ecb-enquiry-active':
              enquiry.isActive,

            'ecb-enquiry-inactive':
              !enquiry.isActive
          }">

                                {{
                                enquiry.isActive
                                ? 'Active'
                                : 'Inactive'
                                }}

                            </span>


                        </td>

                        <!-- Active Status -->
                        <td class="ecb-admin-table-cell text-center">



                            <span class="ecb-enquiry-active-status">{{getTrainingDate(enquiry)}}</span>

                        </td>


                        <!-- Created Date -->
                        <td class="ecb-admin-table-cell">

                            <span class="ecb-enquiry-created-date">

                                {{
                                enquiry.createdDate
                                ? (enquiry.createdDate | date:'dd/MM/yyyy hh:mm a')
                                : '-'
                                }}

                            </span>

                        </td>


                        <!-- Action -->
                        <td class="ecb-admin-table-cell ecb-admin-table-action-cell">

                            <button type="button" class="ecb-admin-table-action-button ecb-admin-table-view-button"
                                (click)="openEnquiryDetails(enquiry)" title="View enquiry">

                                <i class="bi bi-eye ecb-admin-table-action-icon">
                                </i>

                            </button>



                        </td>


                        <!-- Registration -->
                        <td class="ecb-admin-table-cell text-center">

                            <!-- Submitted -->
                            <button *ngIf="enquiry.registrationBody" type="button"
                                class="ecb-admin-table-action-button ecb-admin-table-view-button"
                                (click)="openRegistrationDetails(enquiry)" title="View registration">

                                <i class="bi bi-file-earmark-text ecb-admin-table-action-icon">
                                </i>

                            </button>


                            <!-- Not Submitted -->
                            <span *ngIf="!enquiry.registrationBody" class="ecb-registration-not-submitted">

                                <i class="bi bi-clock"></i>

                                Not Submitted

                            </span>

                        </td>

                    </tr>

                </ng-template>


                <!-- =====================================================
       Empty
  ====================================================== -->

                <ng-template pTemplate="emptymessage">

                    <tr class="ecb-admin-table-row">

                        <td colspan="12" class="ecb-admin-table-cell text-center py-5 ecb-muted">

                            <i class="bi bi-inbox ecb-enquiry-empty-icon"></i>

                            <div>
                                No training enquiries found.
                            </div>

                        </td>

                    </tr>

                </ng-template>

            </p-table>

            <!-- Start Enquiries Table Footer -->
            <div class="ecb-x-admin-enquiries-table-footer">

                <div class="row align-items-center gy-3">

                    <!-- Showing Records -->
                    <div class="col-12 col-lg-4">

                        <div class="ecb-x-admin-enquiries-paginator-info">

                            Showing
                            {{ startRecord }}–{{ endRecord }}
                            of {{ totalRecords }} enquiries

                        </div>

                    </div>


                    <!-- Rows Per Page -->
                    <div class="col-12 col-lg-4">

                        <div class="ecb-x-admin-enquiries-paginator-size">

                            <label>
                                Rows per page
                            </label>

                            <select class="form-select form-select-sm" [(ngModel)]="pageSize" [disabled]="isLoading"
                                (ngModelChange)="onPageSizeChange()">

                                <option [ngValue]="10">10</option>
                                <option [ngValue]="20">20</option>
                                <option [ngValue]="50">50</option>
                                <option [ngValue]="100">100</option>

                            </select>

                        </div>

                    </div>


                    <!-- Page Navigation -->
                    <div class="col-12 col-lg-4">

                        <div class="ecb-x-admin-enquiries-paginator-navigation">

                            <!-- Previous -->
                            <button type="button" class="ecb-x-admin-enquiries-page-button"
                                [disabled]="pageNo === 1 || isLoading" (click)="previousPage()">

                                Previous

                            </button>


                            <!-- Page Numbers -->
                            <button type="button" *ngFor="let page of pageNumbers"
                                class="ecb-x-admin-enquiries-page-button"
                                [class.ecb-x-admin-enquiries-page-active]="pageNo === page" [disabled]="isLoading"
                                [attr.aria-current]="pageNo === page ? 'page' : null" (click)="changePage(page)">

                                {{ page }}

                            </button>


                            <!-- Next -->
                            <button type="button" class="ecb-x-admin-enquiries-page-button"
                                [disabled]="pageNo === totalPages || isLoading" (click)="nextPage()">

                                Next

                            </button>

                        </div>

                    </div>

                </div>

            </div>
            <!-- End Enquiries Table Footer -->


            <!-- Error -->
            <div *ngIf="errorMessage" class="alert alert-danger mt-3 mb-0">

                <i class="bi bi-exclamation-circle me-2"></i>

                {{ errorMessage }}

            </div>

        </div>
    </div>
</section>


<!-- Enquiry details modal -->
<div class="ecb-enquiry-modal-backdrop" *ngIf="showDetailsModal" (click)="closeEnquiryDetails()">

    <div class="ecb-enquiry-details-modal" (click)="$event.stopPropagation()">

        <!-- Modal header -->
        <div class="ecb-enquiry-details-header">

            <div>

                <span class="ecb-enquiry-details-reference">

                    #{{ ReferencePrefix }}{{ selectedEnquiry?.id }}

                </span>

                <h3>

                    {{
                    isSelectedEnquiryCorporate()
                    ? 'Corporate Enquiry Details'
                    : 'General Enquiry Details'
                    }}

                </h3>

            </div>


            <button type="button" class="ecb-enquiry-modal-close" (click)="closeEnquiryDetails()">

                <i class="bi bi-x-lg"></i>

            </button>

        </div>


        <!-- Modal body -->
        <div class="ecb-enquiry-details-body" *ngIf="selectedEnquiryBody">


            <!-- Corporate enquiry -->
            <ng-container *ngIf="isSelectedEnquiryCorporate()">


                <!-- Client details -->
                <div class="ecb-enquiry-details-section">

                    <h4>
                        Client Details
                    </h4>

                    <div class="row g-3">


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Company Name
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.companyName ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Company Email
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.companyEmail ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Requested By
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.requestedBy ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Requested By Phone
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.requestedByPhone ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    On Site Supervisor
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.onSiteSupervisor ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Supervisor Phone
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.onSiteSupervisorPhone ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Site Location / Address
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.siteLocationAddress ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Date Requested
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.dateRequested
                                    ? (
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.dateRequested
                                    | date:'dd/MM/yyyy'
                                    )
                                    : '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Training Date Required
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.dateTrainingRequired
                                    ? (
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.dateTrainingRequired
                                    | date:'dd/MM/yyyy'
                                    )
                                    : '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-4">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Copy of Awards Required
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.copyOfAwardsRequired ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-4">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Metro Client
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.isMetroClient ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-4">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Upload Award Evidence to Pegasus
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.clientDetails
                                    ?.uploadAwardEvidenceToPegasus ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>

                    </div>

                </div>



                <!-- Corporate participants -->
                <div class="ecb-enquiry-details-section" *ngIf="
            selectedEnquiryBody
              ?.participants
              ?.length
          ">

                    <h4>
                        Participants
                    </h4>


                    <div class="ecb-enquiry-participant-card" *ngFor="
              let participant of selectedEnquiryBody.participants;
              let participantIndex = index
            ">


                        <div class="ecb-enquiry-participant-header">

                            <strong>

                                Participant
                                {{
                                participant
                                ?.participantNo ||
                                participantIndex + 1
                                }}
                                -
                                {{
                                participant
                                ?.fullName ||
                                '-'
                                }}

                            </strong>




                        </div>


                        <!-- UOC courses -->
                        <div class="ecb-enquiry-course-group" *ngIf="
                participant
                  ?.uocCourses
                  ?.length
              ">

                            <span>
                                UOC
                            </span>

                            <div>

                                <div class=" ecb-enquiry-selected-course-uoc" *ngFor="
                    let course of participant.uocCourses
                  ">

                                    <strong>

                                        {{
                                        course
                                        ?.courseCode ||
                                        '-'
                                        }}

                                    </strong>

                                    <small>

                                        {{
                                        course
                                        ?.courseTitle ||
                                        '-'
                                        }}

                                    </small>

                                </div>

                            </div>

                        </div>


                        <!-- VOC courses -->
                        <div class="ecb-enquiry-course-group" *ngIf="
                participant
                  ?.vocCourses
                  ?.length
              ">

                            <span>
                                VOC
                            </span>

                            <div>

                                <div class="ecb-enquiry-selected-course" *ngFor="
                    let voc of participant.vocCourses
                  ">

                                    <strong>

                                        {{
                                        voc
                                        ?.vocCode ||
                                        '-'
                                        }}

                                    </strong>

                                    <small>

                                        {{
                                        voc
                                        ?.vocName ||
                                        '-'
                                        }}

                                    </small>

                                </div>

                            </div>

                        </div>



                        <!-- COA courses -->
                        <div class="ecb-enquiry-course-group" *ngIf="
        participant
            ?.coaCourses
            ?.length
    ">

                            <span>
                                COA
                            </span>

                            <div>

                                <div class="ecb-enquiry-selected-course" *ngFor="
                let coa of participant.coaCourses
            ">

                                    <strong>
                                        COA {{ coa?.slot || '' }}
                                    </strong>

                                    <small>
                                        {{
                                        coa?.courseName ||
                                        '-'
                                        }}
                                    </small>

                                </div>

                            </div>

                        </div>
                    </div>

                </div>


                <!-- Other requirements -->
                <div class="ecb-enquiry-details-section" *ngIf="
            selectedEnquiryBody
              ?.others
              ?.length
          ">

                    <h4>
                        Other Requirements
                    </h4>


                    <div class="ecb-enquiry-other-row" *ngFor="
              let otherRow of selectedEnquiryBody.others;
              let otherIndex = index
            ">

                        <span>

                            Row
                            {{
                            otherRow
                            ?.rowNo ||
                            otherIndex + 1
                            }}

                        </span>

                        <div>

                            <ng-container *ngFor="
                  let otherValue of otherRow.values
                ">

                                <span class="ecb-enquiry-other-value" *ngIf="otherValue?.value">

                                    {{
                                    otherValue.value
                                    }}

                                </span>

                            </ng-container>

                        </div>

                    </div>

                </div>


                <!-- Additional comments -->
                <div class="ecb-enquiry-details-section" *ngIf="
            selectedEnquiryBody
              ?.additionalComments
          ">

                    <h4>
                        Additional Comments
                    </h4>

                    <p class="ecb-enquiry-comments">

                        {{
                        selectedEnquiryBody
                        ?.additionalComments
                        }}

                    </p>

                </div>

            </ng-container>



            <!-- General enquiry -->
            <ng-container *ngIf="isSelectedEnquiryGeneral()">


                <!-- Participant details -->
                <div class="ecb-enquiry-details-section">

                    <h4>
                        <span *ngIf="selectedEnquiryBody.clientType !== 'OTHER_COURSE_ENQUIRY'">Participant</span>
                        Details
                    </h4>

                    <div class="row g-3">


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Given Name
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.participant
                                    ?.givenName ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Family Name
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.participant
                                    ?.familyName ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Email Address
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.participant
                                    ?.email ||
                                    selectedEnquiry
                                    ?.sentBy ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Mobile No
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.participant
                                    ?.contactNumber ||
                                    '-'
                                    }}


                                </strong>

                            </div>

                        </div>

                    </div>

                </div>


                <!-- Primary course -->
                <div class="ecb-enquiry-details-section">

                    <h4>
                        Primary Course
                    </h4>

                    <div class="row g-3">


                        <div class="col-12 col-md-4">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Course Code
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.courseCode ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-8">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Course Title
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.courseTitle ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12">


                            <div class="row">
                                <div class="col-12">
                                    <div class="ecb-enquiry-description-field">
                                        <span>Description</span>

                                        <div class="ecb-enquiry-description-content"
                                            [innerHTML]="selectedEnquiryBody.primaryCourse.description">
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>


                        <div class="col-12 col-md-4" *ngIf="selectedEnquiryBody?.clientType != 'OTHER_COURSE_ENQUIRY'">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Course Fee
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.currencyCode ||
                                    'AUD'
                                    }}
                                    ${{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.totalAmount
                                    | number:'1.2-2'
                                    }}

                                </strong>

                            </div>

                        </div>


                   <!--      <div class="col-12 col-md-4" *ngIf="selectedEnquiryBody?.clientType != 'OTHER_COURSE_ENQUIRY'">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Document Types
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.documentTypes ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div> -->


                     <!--    <div class="col-12 col-md-4" *ngIf="selectedEnquiryBody?.clientType != 'OTHER_COURSE_ENQUIRY'">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Course ID
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.courseId ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div> -->

                    </div>

                </div>


                <!-- Course occurrence -->
                <div class="ecb-enquiry-details-section" *ngIf="
            selectedEnquiryBody
              ?.primaryCourse
              ?.occurrence
          ">

                    <h4>
                        Course Occurrence
                    </h4>

                    <div class="row g-3">


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Start Date
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.startDate
                                    ? (
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.startDate
                                    | date:'dd/MM/yyyy hh:mm a'
                                    )
                                    : '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    End Date
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.endDate
                                    ? (
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.endDate
                                    | date:'dd/MM/yyyy hh:mm a'
                                    )
                                    : '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Location
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.location ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-4">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Capacity
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.capacity ??
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-4">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Available Seats
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.availableSeats ??
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-4">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Occurrence ID
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.occurrenceId ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Registration Start Date
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.registrationStartDate
                                    ? (
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.registrationStartDate
                                    | date:'dd/MM/yyyy'
                                    )
                                    : '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Registration End Date
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.registrationEndDate
                                    ? (
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.registrationEndDate
                                    | date:'dd/MM/yyyy'
                                    )
                                    : '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    VETtrak Occurrence ID
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.vettrackOccuranceId ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    VETtrak Job Number
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.primaryCourse
                                    ?.occurrence
                                    ?.vettrackJobNumber ||
                                    '-'
                                    }}

                                </strong>

                            </div>

                        </div>

                    </div>

                </div>


                <!-- Additional UOC courses -->
                <div class="ecb-enquiry-details-section" *ngIf="
            selectedEnquiryBody
              ?.additionalUOCCourses
              ?.length
          ">

                    <h4>
                        Additional UOC Courses
                    </h4>


                    <div class="ecb-enquiry-participant-card">

                        <div class="ecb-enquiry-course-group">

                            <span>
                                UOC
                            </span>

                            <div>

                                <div class="ecb-enquiry-selected-course-uoc" *ngFor="
                    let course of selectedEnquiryBody.additionalUOCCourses
                  ">

                                    <strong>

                                        {{
                                        course
                                        ?.courseCode ||
                                        '-'
                                        }}

                                    </strong>

                                    <small>

                                        {{
                                        course
                                        ?.courseTitle ||
                                        '-'
                                        }}

                                    </small>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>


                <!-- VOC courses -->
                <div class="ecb-enquiry-details-section" *ngIf="
            selectedEnquiryBody
              ?.vocCourses
              ?.length
          ">

                    <h4>
                        VOC Courses
                    </h4>


                    <div class="ecb-enquiry-participant-card">

                        <div class="ecb-enquiry-course-group">

                            <span>
                                VOC
                            </span>

                            <div>

                                <div class="ecb-enquiry-selected-course" *ngFor="
                    let voc of selectedEnquiryBody.vocCourses
                  ">

                                    <strong>

                                        {{
                                        voc
                                        ?.vocCode ||
                                        '-'
                                        }}

                                    </strong>

                                    <small>

                                        {{
                                        voc
                                        ?.vocName ||
                                        '-'
                                        }}

                                    </small>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>


                <!-- General booking summary -->
                <div class="ecb-enquiry-details-section"
                    *ngIf="selectedEnquiryBody?.clientType != 'OTHER_COURSE_ENQUIRY'">

                    <h4>
                        Enquiry Summary
                    </h4>

                    <div class="row g-3">


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Total Selected Courses
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.totalCourses ??
                                    0
                                    }}

                                </strong>

                            </div>

                        </div>


                        <div class="col-12 col-md-6">

                            <div class="ecb-enquiry-details-field">

                                <span>
                                    Submitted Date
                                </span>

                                <strong>

                                    {{
                                    selectedEnquiryBody
                                    ?.createdDate
                                    ? (
                                    selectedEnquiryBody
                                    ?.createdDate
                                    | date:'dd/MM/yyyy hh:mm a'
                                    )
                                    : '-'
                                    }}

                                </strong>

                            </div>

                        </div>

                    </div>

                </div>

            </ng-container>

        </div>


        <!-- Approval success -->
        <div class="alert alert-success mx-4" *ngIf="approvalSuccessMessage">

            <i class="bi bi-check-circle me-2"></i>

            {{ approvalSuccessMessage }}

        </div>


        <!-- Approval error -->
        <div class="alert alert-danger mx-4" *ngIf="approvalErrorMessage">

            <i class="bi bi-exclamation-circle me-2"></i>

            {{ approvalErrorMessage }}

        </div>


        <!-- Modal footer -->
        <div class="ecb-enquiry-modal-footer">

            <div>

                <span class="ecb-enquiry-approved-label" *ngIf="selectedEnquiry?.isApproved">

                    <i class="bi bi-check-circle-fill"></i>

                    Accepted

                </span>


                <span class="ecb-enquiry-awaiting-label" *ngIf="!selectedEnquiry?.isApproved">

                    <i class="bi bi-clock"></i>

                    Awaiting Approval

                </span>

            </div>


            <div class="d-flex gap-2">

                <button type="button" class="btn ecb-enquiry-close-button" [disabled]="isApprovingEnquiry"
                    (click)="closeEnquiryDetails()">

                    Close

                </button>


                <button type="button" class="btn ecb-enquiry-approve-button" *ngIf="!selectedEnquiry?.isApproved"
                    [disabled]="isApprovingEnquiry" (click)="approveSelectedEnquiry()">

                    <ng-container *ngIf="!isApprovingEnquiry">

                        <i class="bi bi-check-circle"></i>

                        Accept Enquiry

                    </ng-container>


                    <ng-container *ngIf="isApprovingEnquiry">

                        <span class="spinner-border spinner-border-sm">
                        </span>

                        Approving...

                    </ng-container>

                </button>


                <button type="button" class="btn ecb-enquiry-approve-button"
                    *ngIf="selectedEnquiry?.isApproved &&   !selectedEnquiry.registrationBody"
                    [disabled]="isApprovingEnquiry" (click)="openApprovalPopup()">

                    <ng-container *ngIf="!isApprovingEnquiry">

                        <i class="bi bi-check-circle"></i>

                        Send Registration Form

                    </ng-container>


                    <ng-container *ngIf="isApprovingEnquiry">

                        <span class="spinner-border spinner-border-sm">
                        </span>

                        Sending...

                    </ng-container>

                </button>

            </div>

        </div>

    </div>

</div>


<!-- Registration modal -->
<!-- =========================================================
     REGISTRATION DETAILS MODAL
========================================================= -->

<div class="ecb-registration-modal-backdrop" *ngIf="showRegistrationModal" (click)="closeRegistrationDetails()">


    <div class="ecb-registration-modal" (click)="$event.stopPropagation()">


        <!-- =====================================================
             MODAL HEADER
        ====================================================== -->

        <div class="ecb-registration-modal-header">

            <div>

                <span class="ecb-registration-reference">
                    #{{ ReferencePrefix }}{{ selectedRegistrationEnquiry?.id }}
                </span>


                <h2>
                    Booking Registration Details
                </h2>


                <p>
                    Review the submitted participant registration information.
                </p>

            </div>


            <button type="button" class="ecb-registration-close-button" (click)="closeRegistrationDetails()">

                <i class="bi bi-x-lg"></i>

            </button>

        </div>


        <!-- =====================================================
             MODAL CONTENT
        ====================================================== -->

        <div class="ecb-registration-modal-scroll">


            <div class="ecb-registration-document">


                <!-- =================================================
                     DOCUMENT HEADER
                ================================================== -->

                <div class="ecb-registration-document-header">

                    <div>

                        <h1>
                            Booking Registration
                        </h1>

                        <span>
                            Booking Registration Details
                        </span>

                    </div>


                    <div class="ecb-registration-document-reference">

                        <small>
                            Booking Reference
                        </small>

                        <strong>
                            #{{ ReferencePrefix }}{{ selectedRegistrationEnquiry?.id }}
                        </strong>

                    </div>

                </div>



                <!-- =================================================
                     PARTICIPANTS
                ================================================== -->

                <div class="ecb-registration-participant-document" *ngFor="
                        let participant
                        of selectedRegistration?.participantRegistrations;

                        let participantIndex = index
                    ">


                    <!-- =============================================
                         PARTICIPANT HEADER
                    ============================================== -->

                    <div class="ecb-registration-participant-title">


                        <div class="ecb-registration-participant-number">

                            {{
                            participant?.participantNo
                            ||
                            participantIndex + 1
                            }}

                        </div>


                        <div>

                            <span>
                                Participant
                            </span>


                            <h3>

                                {{ participant?.firstName }}

                                {{ participant?.lastName }}

                            </h3>

                        </div>


                    </div>


                    <!-- =============================================
                         PERSONAL DETAILS
                    ============================================== -->

                    <div class="ecb-registration-document-section">

                        <h4>
                            Personal Details
                        </h4>


                        <div class="ecb-registration-details-grid">


                            <div>

                                <span>
                                    First Name
                                </span>

                                <strong>
                                    {{
                                    participant?.firstName
                                    ||
                                    '-'
                                    }}
                                </strong>

                            </div>


                            <div>

                                <span>
                                    Last Name
                                </span>

                                <strong>
                                    {{
                                    participant?.lastName
                                    ||
                                    '-'
                                    }}
                                </strong>

                            </div>


                            <div>

                                <span>
                                    Date of Birth
                                </span>

                                <strong>

                                    {{
                                    participant?.dateOfBirth
                                    ? (
                                    participant?.dateOfBirth
                                    | date:'dd/MM/yyyy'
                                    )
                                    : '-'
                                    }}

                                </strong>

                            </div>


                            <div>

                                <span>
                                    Email Address
                                </span>

                                <strong>
                                    {{
                                    participant?.emailAddress
                                    ||
                                    '-'
                                    }}
                                </strong>

                            </div>


                            <div>

                                <span>
                                    Mobile Number
                                </span>

                                <strong>
                                    {{
                                    participant?.mobileNumber
                                    ||
                                    '-'
                                    }}
                                </strong>

                            </div>


                            <div class="ecb-registration-grid-full">

                                <span>
                                    Address
                                </span>

                                <strong>
                                    {{
                                    participant?.address
                                    ||
                                    '-'
                                    }}
                                </strong>

                            </div>


                        </div>

                    </div>


                    <!-- =============================================
                         EDUCATION
                         HIDE WHEN VOC ONLY
                    ============================================== -->

                    <div class="ecb-registration-document-section" *ngIf="
                            !isVocOnlyParticipant(participant)
                            &&
                            participant?.education
                        ">


                        <h4>
                            Education
                        </h4>


                        <div class="ecb-registration-details-grid">


                            <!-- Education -->
                            <div>

                                <span>
                                    Education
                                </span>

                                <strong>

                                    {{
                                    participant
                                    ?.education
                                    ?.qualificationName
                                    ||
                                    '-'
                                    }}

                                </strong>

                            </div>


                            <!-- Education Type -->



                            <!-- USI -->
                            <div *ngIf="
                                    participant
                                        ?.education
                                        ?.usi
                                ">

                                <span>
                                    USI
                                </span>

                                <strong>

                                    {{
                                    participant
                                    ?.education
                                    ?.usi
                                    }}

                                </strong>

                            </div>


                        </div>

                    </div>


                    <!-- =============================================
                         QUALIFICATION CERTIFICATES
                         PREVIEWS ONLY
                    ============================================== -->

                    <div class="ecb-registration-document-section" *ngIf="
                            participant
                                ?.qualification
                                ?.certificates
                                ?.length
                        ">


                        <h4>
                            Qualification Certificates
                        </h4>


                        <div class="ecb-registration-document-preview" *ngFor="
                                let certificate
                                of participant
                                    ?.qualification
                                    ?.certificates;

                                let certificateIndex = index
                            ">


                            <!-- Preview Header -->
                            <div class="ecb-registration-preview-header">


                                <div>

                                    <i class="bi bi-file-earmark-check"></i>


                                    <strong>

                                        Certificate Document

                                        <ng-container *ngIf="
                                                participant
                                                    ?.qualification
                                                    ?.certificates
                                                    ?.length > 1
                                            ">

                                            {{ certificateIndex + 1 }}

                                        </ng-container>

                                    </strong>

                                </div>


                                <a *ngIf="certificate?.fileUrl" [href]="certificate?.fileUrl" target="_blank"
                                    rel="noopener noreferrer">

                                    Open Original

                                    <i class="bi bi-box-arrow-up-right"></i>

                                </a>


                            </div>


                            <!-- Preview Content -->
                            <div class="ecb-registration-preview-content">


                                <!-- IMAGE -->
                                <img *ngIf="
                                        isImageFile(
                                            certificate?.fileType,
                                            certificate?.fileName
                                        )
                                    " class="ecb-registration-image-preview" [ngStyle]="
                                        getDocumentImageStyle(
                                            'certificate'
                                        )
                                    " [src]="certificate?.fileUrl" alt="Certificate document">


                                <!-- PDF -->
                                <iframe *ngIf="
                                        isPdfFile(
                                            certificate?.fileType,
                                            certificate?.fileName
                                        )
                                    " class="ecb-registration-pdf-preview" [ngStyle]="
                                        getDocumentPdfStyle(
                                            'certificate'
                                        )
                                    " [src]="
                                        getSafeDocumentUrl(
                                            certificate?.fileUrl
                                        )
                                    ">
                                </iframe>


                            </div>

                        </div>


                    </div>


                    <!-- =============================================
                         OLD CERTIFICATE FALLBACK
                    ============================================== -->

                    <div class="ecb-registration-document-section" *ngIf="
                            !participant
                                ?.qualification
                                ?.certificates
                                ?.length
                            &&
                            participant
                                ?.qualification
                                ?.certificateFileUrl
                        ">


                        <h4>
                            Qualification Certificates
                        </h4>


                        <div class="ecb-registration-document-preview">


                            <div class="ecb-registration-preview-header">

                                <div>

                                    <i class="bi bi-file-earmark-check"></i>

                                    <strong>
                                        Certificate Document
                                    </strong>

                                </div>


                                <a [href]="
                                        participant
                                            ?.qualification
                                            ?.certificateFileUrl
                                    " target="_blank" rel="noopener noreferrer">

                                    Open Original

                                    <i class="bi bi-box-arrow-up-right"></i>

                                </a>

                            </div>


                            <div class="ecb-registration-preview-content">


                                <!-- IMAGE -->
                                <img *ngIf="
                                        isImageFile(
                                            participant
                                                ?.qualification
                                                ?.certificateFileType,

                                            participant
                                                ?.qualification
                                                ?.certificateFileName
                                        )
                                    " class="ecb-registration-image-preview" [ngStyle]="
                                        getDocumentImageStyle(
                                            'certificate'
                                        )
                                    " [src]="
                                        participant
                                            ?.qualification
                                            ?.certificateFileUrl
                                    " alt="Certificate document">


                                <!-- PDF -->
                                <iframe *ngIf="
                                        isPdfFile(
                                            participant
                                                ?.qualification
                                                ?.certificateFileType,

                                            participant
                                                ?.qualification
                                                ?.certificateFileName
                                        )
                                    " class="ecb-registration-pdf-preview" [ngStyle]="
                                        getDocumentPdfStyle(
                                            'certificate'
                                        )
                                    " [src]="
                                        getSafeDocumentUrl(
                                            participant
                                                ?.qualification
                                                ?.certificateFileUrl
                                        )
                                    ">
                                </iframe>


                            </div>

                        </div>

                    </div>


                    <!-- =============================================
                         IDENTITY DOCUMENTS
                         PREVIEWS ONLY
                    ============================================== -->

                    <div class="ecb-registration-document-section" *ngIf="
                            participant
                                ?.identities
                                ?.length
                        ">


                        <h4>
                            Identity Documents
                        </h4>


                        <div class="ecb-registration-document-preview" *ngFor="
                                let identity
                                of participant?.identities;

                                let identityIndex = index
                            ">


                            <!-- Preview Header -->
                            <div class="ecb-registration-preview-header">


                                <div>

                                    <i class="bi bi-person-vcard"></i>


                                    <strong>

                                        Identity Document

                                        <ng-container *ngIf="
                                                participant
                                                    ?.identities
                                                    ?.length > 1
                                            ">

                                            {{ identityIndex + 1 }}

                                        </ng-container>

                                    </strong>

                                </div>


                                <a *ngIf="identity?.idFileUrl" [href]="identity?.idFileUrl" target="_blank"
                                    rel="noopener noreferrer">

                                    Open Original

                                    <i class="bi bi-box-arrow-up-right"></i>

                                </a>


                            </div>


                            <!-- Preview Content -->
                            <div class="ecb-registration-preview-content">


                                <!-- IMAGE -->
                                <img *ngIf="
                                        isImageFile(
                                            identity?.idFileType,
                                            identity?.idFileName
                                        )
                                    " class="ecb-registration-image-preview" [ngStyle]="
                                        getDocumentImageStyle(
                                            'identity'
                                        )
                                    " [src]="identity?.idFileUrl" alt="Identity document">


                                <!-- PDF -->
                                <iframe *ngIf="
                                        isPdfFile(
                                            identity?.idFileType,
                                            identity?.idFileName
                                        )
                                    " class="ecb-registration-pdf-preview" [ngStyle]="
                                        getDocumentPdfStyle(
                                            'identity'
                                        )
                                    " [src]="
                                        getSafeDocumentUrl(
                                            identity?.idFileUrl
                                        )
                                    ">
                                </iframe>


                            </div>

                        </div>


                    </div>


                    <!-- =============================================
                         OLD SINGLE ID FALLBACK
                    ============================================== -->

                    <div class="ecb-registration-document-section" *ngIf="
                            !participant
                                ?.identities
                                ?.length
                            &&
                            participant
                                ?.identity
                                ?.idFileUrl
                        ">


                        <h4>
                            Identity Documents
                        </h4>


                        <div class="ecb-registration-document-preview">


                            <div class="ecb-registration-preview-header">

                                <div>

                                    <i class="bi bi-person-vcard"></i>

                                    <strong>
                                        Identity Document
                                    </strong>

                                </div>


                                <a [href]="
                                        participant
                                            ?.identity
                                            ?.idFileUrl
                                    " target="_blank" rel="noopener noreferrer">

                                    Open Original

                                    <i class="bi bi-box-arrow-up-right"></i>

                                </a>

                            </div>


                            <div class="ecb-registration-preview-content">


                                <!-- IMAGE -->
                                <img *ngIf="
                                        isImageFile(
                                            participant
                                                ?.identity
                                                ?.idFileType,

                                            participant
                                                ?.identity
                                                ?.idFileName
                                        )
                                    " class="ecb-registration-image-preview" [ngStyle]="
                                        getDocumentImageStyle(
                                            'identity'
                                        )
                                    " [src]="
                                        participant
                                            ?.identity
                                            ?.idFileUrl
                                    " alt="Identity document">


                                <!-- PDF -->
                                <iframe *ngIf="
                                        isPdfFile(
                                            participant
                                                ?.identity
                                                ?.idFileType,

                                            participant
                                                ?.identity
                                                ?.idFileName
                                        )
                                    " class="ecb-registration-pdf-preview" [ngStyle]="
                                        getDocumentPdfStyle(
                                            'identity'
                                        )
                                    " [src]="
                                        getSafeDocumentUrl(
                                            participant
                                                ?.identity
                                                ?.idFileUrl
                                        )
                                    ">
                                </iframe>


                            </div>

                        </div>

                    </div>


                </div>


                <!-- =================================================
                     SUBMISSION FOOTER
                ================================================== -->

                <div class="ecb-registration-submission-footer">

                    <span>
                        Registration Submitted
                    </span>


                    <strong>

                        {{
                        selectedRegistration
                        ?.submittedDate
                        ? (
                        selectedRegistration
                        ?.submittedDate
                        | date:'dd/MM/yyyy'
                        )
                        : '-'
                        }}

                    </strong>

                </div>


            </div>

        </div>

    </div>

</div>



<div class="ecb-approval-popup-backdrop" *ngIf="showApprovalPopup" (click)="closeApprovalPopup()">
    <div class="ecb-approval-popup" (click)="$event.stopPropagation()">
        <!-- Display the popup header. -->
        <div class="ecb-approval-popup-header">
            <div>
                <span class="ecb-approval-popup-label">ENQUIRY#{{ selectedEnquiry?.id }}</span>
                <h4 class="mb-1" *ngIf="!editDatePopup">Approve Booking</h4>
                <h4 class="mb-1" *ngIf="editDatePopup">Edit Training Date</h4>
                <p class="mb-0">Confirm or change the training required date.</p>
            </div>
            <button type="button" class="ecb-approval-popup-close" (click)="closeApprovalPopup()">
                <i class="bi bi-x-lg"></i>
            </button>
        </div>

        <!-- Display the popup content. -->
        <div class="ecb-approval-popup-body">
            <label for="approvalTrainingDate" class="form-label fw-semibold">
                Training Required Date
                <span class="text-danger">*</span>
            </label>
            <input id="approvalTrainingDate" type="date" [min]="todayDate" class="form-control"
                [(ngModel)]="approvalTrainingDate" name="approvalTrainingDate">
            <div class="ecb-approval-date-error" *ngIf="approvalDateError">
                <i class="bi bi-exclamation-circle"></i>
                {{ approvalDateError }}
            </div>
        </div>

        <!-- Display the popup actions. -->
        <div class="ecb-approval-popup-footer">
            <button type="button" class="btn ecb-enquiry-close-button" [disabled]="isApprovingEnquiry"
                (click)="closeApprovalPopup()">
                Cancel
            </button>
            <button type="button" class="btn ecb-enquiry-approve-button" [disabled]="isApprovingEnquiry"
                (click)="sendRegistration()">
                <ng-container *ngIf="!isApprovingEnquiry">
                    <i class="bi bi-check-circle"></i>
                    Confirm & Send
                </ng-container>
                <ng-container *ngIf="isApprovingEnquiry">
                    <span class="spinner-border spinner-border-sm me-1">
                    </span>
                    Sending...
                </ng-container>
            </button>
        </div>
    </div>
</div>